module.exports = __webpack_public_path__ + "img/jad-success.2df6efa3.svg";